export default __webpack_public_path__ + "static/media/loading.5db72d66.gif";